export default "__VITE_ASSET__C8kfhRCG__"